import { useState, useEffect, useRef } from "react";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";


export default function CustomerCount(props) { 
    const { controller = "", callback = () => { }, route = "", value = "", type = "", initialData = [] } = props;

    const [ data, setData ] = useState(initialData);
    const [selected, setSelected] = useState(initialData[0] || {});
    const [loading, setLoading] = useState(false);
    const offsetRef = useRef(100);

    useEffect(() => {
        if (initialData.length > 0) {
            let _f = initialData.find(item => item.person_id === value);
            if (_f) { setSelected(_f) } else { setSelected(initialData[0])}
        }

        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { key: KBD.ENTER, action: () => callback(selected?.person_id) },
        ];
        const cleanup = listen(controller, route, actions);
        return cleanup;
    }, [initialData, value])

    const loadMore = () => {
        if (loading) return;
        setLoading(true);
        pubCall("customer.searchShop", {type: type, limit: 100, offset: offsetRef.current}, (_s, _r) => {
            if (_s) {
                setData(prev => [...prev, ..._r.rows]);
                offsetRef.current += 100;
            } else {
                showError(_r);
            }
            setLoading(false);
        });
    };

    
    const columns = [
        { key: "ship_to", align: "left", title: <>Account</>, width: 80 },
        { key: "name", align: "left", title: <>Name</>, width: 250 },
        { key: "last_order_date", align: "left", title: <>Last Order</>, width: 120 },
        { key: "discount", align: "right", title: <>%%</>, width: 35, render: (value) => { return value ? value : ""} },
    ]

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.person_id === selected?.person_id);
        const nextIndex = currentIndex + _rows;
        
        if (nextIndex >= data.length - 5 && !loading) {
            loadMore();
        }
        
        if (data.length <= nextIndex) { setSelected(data[0]);}
        if (nextIndex < data.length) { setSelected(data[nextIndex]);}
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.person_id === selected?.person_id) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return;}
        if (prevIndex >= 0) { setSelected(data[prevIndex]);}
    };

    return (
        <>
            <VirtualTable
                controller={controller}
                row_key={"person_id"}
                next={next}
                prev={prev}
                route={route}
                current={selected}
                data={data}
                width={490}
                height={320}
                offset={0}
                columns={columns}
            />
        </>
    )
}